import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const ProcurementSchemeService = Services.procurementScheme;
const ProcurementSchemeTypes = VuexTypes.procurementScheme;
export default {
  [ProcurementSchemeTypes.CATEGORIES_LIST]: ({ commit, state }) => {
    state.categoriesList['status'] = statuses.LOADING;
    ProcurementSchemeService.categoriesList().then((data) => {
      commit(ProcurementSchemeTypes.CATEGORIES_LIST, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORIES_LIST, errResponse);
    });
  },
  [ProcurementSchemeTypes.CATEGORY]: ({ commit, state }, id) => {
    state.category['status'] = statuses.LOADING;
    ProcurementSchemeService.category(id).then((data) => {
      commit(ProcurementSchemeTypes.CATEGORY, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORY, errResponse);
    });
  },
  [ProcurementSchemeTypes.CATEGORY_CREATE_DATA]: ({ commit, state }, id) => {
    state.categoryCreateData['status'] = statuses.LOADING;
    ProcurementSchemeService.categoryCreateData(id).then((data) => {
      commit(ProcurementSchemeTypes.CATEGORY_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORY_CREATE_DATA, errResponse);
    });
  },
  [ProcurementSchemeTypes.CATEGORY_UPDATE_DATA]: ({ commit, state }, id) => {
    state.categoryUpdateData['status'] = statuses.LOADING;
    ProcurementSchemeService.categoryUpdateData(id).then((data) => {
      commit(ProcurementSchemeTypes.CATEGORY_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORY_UPDATE_DATA, errResponse);
    });
  },
  [ProcurementSchemeTypes.CATEGORY_CREATE]: ({ commit, state }, createData) => {
    state.categoryCreate['status'] = statuses.LOADING;
    ProcurementSchemeService.categoryCreate(createData).then((data) => {
      commit(ProcurementSchemeTypes.CATEGORY_CREATE, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORY_CREATE, errResponse);
    });
  },
  [ProcurementSchemeTypes.CATEGORY_UPDATE]: ({ commit, state }, { id, updateData }) => {
    state.categoryUpdate['status'] = statuses.LOADING;
    ProcurementSchemeService.categoryUpdate(id, updateData).then((data) => {
      commit(ProcurementSchemeTypes.CATEGORY_UPDATE, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.CATEGORY_UPDATE, errResponse);
    });
  },


  [ProcurementSchemeTypes.PRODUCTS_LIST]: ({ commit, state }, params) => {
    state.productsList['status'] = statuses.LOADING;
    ProcurementSchemeService.productsList(params).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCTS_LIST, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCTS_LIST, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT]: ({ commit, state }, id) => {
    state.product['status'] = statuses.LOADING;
    ProcurementSchemeService.product(id).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_CREATE_DATA]: ({ commit, state }, id) => {
    state.productCreateData['status'] = statuses.LOADING;
    ProcurementSchemeService.productCreateData(id).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_CREATE_DATA, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE_DATA]: ({ commit, state }, id) => {
    state.productUpdateData['status'] = statuses.LOADING;
    ProcurementSchemeService.productUpdateData(id).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE_DATA, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_CREATE]: ({ commit, state }, createData ) => {
    state.productCreate['status'] = statuses.LOADING;
    ProcurementSchemeService.productCreate(createData).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_CREATE, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_CREATE, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE]: ({ commit, state }, { id, updateData }) => {
    state.productUpdate['status'] = statuses.LOADING;
    ProcurementSchemeService.productUpdate(id, updateData).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_CLASSIFIERS]: ({ commit, state }) => {
    state.productClassifiers['status'] = statuses.LOADING;
    ProcurementSchemeService.productClassifiers().then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_CLASSIFIERS, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_CLASSIFIERS, errResponse);
    });
  },
  [ProcurementSchemeTypes.PRODUCT_UPDATE_ACTIVE]: ({ commit, state }, { id, isActive }) => { // isActive 0/1
    state.productUpdateActive['status'] = statuses.LOADING;
    ProcurementSchemeService.productUpdateActive(id, isActive).then((data) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE_ACTIVE, data);
    }).catch((errResponse) => {
      commit(ProcurementSchemeTypes.PRODUCT_UPDATE_ACTIVE, errResponse);
    });
  },
};
